<template>
  <div class="download-qh">
    <div class="white-wrap">
      <div class="close" @click="backClick"></div>
      <div class="back" @click="backClick"></div>
      <div class="title">设备端绑定教程-威联通</div>
      <div class="left-nav">
        <div
          class="nav-item"
          :class="{ 'active-item1': checkedElement == 'download' }"
          @click="goClick('download')"
        >
          <div class="nav-icon"></div>
          安装
        </div>
        <div
          class="nav-item nav-item2"
          :class="{ 'active-item2': checkedElement == 'install' }"
          @click="goClick('install')"
        >
          <div class="nav-icon"></div>
          绑定
        </div>
        <div class="contact">
          <div class="contact-icon"></div>
          联系客服
          <div class="contact-alert">
            <img
              :src="require('../../assets/remote/contact-alert-qrcode.png')"
            />
            <div class="contact-alert-tips">扫码加入群聊获取客服帮助</div>
          </div>
        </div>
      </div>
      <div class="right" @scroll="downloadScroll" id="qh">
        <div class="content-title content-title1 title-class" id="download">
          <div class="title-icon"></div>
          App Center安装节点小宝
        </div>
        <div class="content-text">打开App Center，搜索并下载节点小宝。</div>
        <div class="content-text2">手动安装</div>
        <div class="content-text">通过节点小宝官网下载安装包进行手动安装。</div>
        <div
          class="content-text3"
          @click="openUrl('http://jdxb.ionewu.com/download')"
        >
          http://jdxb.ionewu.com/download
        </div>
        <div class="content-title content-title2">
          <div class="title-icon"></div>
          启动节点小宝
        </div>
        <div class="content-text">安装完成后启动节点小宝，跳转至网页版。</div>
        <div class="content-title content-title3" id="install">
          <div class="title-icon"></div>
          登录节点小宝并绑定设备
        </div>
        <div class="content-text">
          登录后即显示绑定弹窗，点击“立即绑定”即可绑定NAS设备。
        </div>
        <div class="content-text">
          若未出现绑定弹窗，请从应用中心再次打开节点小宝
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadQh",
  data: function () {
    return {
      isScrollLock: false,
      checkedElement: "download",
    };
  },
  methods: {
    openUrl: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
    backClick: function () {
      let _that = this;
      _that.$store.state.isShowDownload = 2;
    },
    goClick: function (data) {
      let _that = this;
      _that.checkedElement = data;
      let target = document.getElementById(data);
      target.parentNode.scrollTop = target.offsetTop - 100; //元素上边距（相对于第一个定位的父元素）
      _that.isScrollLock = true;
      setTimeout(function () {
        _that.isScrollLock = false;
      }, 100);
    },
    downloadScroll: function () {
      let _that = this;
      if (_that.isScrollLock) {
        return;
      }
      let heads = document.getElementsByClassName("title-class");
      let headsOffsetTops = [];
      for (let index = 0; index < heads.length; index++) {
        let o = {
          id: heads[index].id,
          offsetTop: heads[index].offsetTop, //当前对象到其上级层顶部的距离.
        };
        headsOffsetTops.push(o);
      }
      let st = document.getElementById("qh").scrollTop; //当前元素顶端距离窗口顶端距离
      st += 100;
      for (let index = headsOffsetTops.length - 1; index >= 0; index--) {
        if (st > headsOffsetTops[index].offsetTop) {
          _that.checkedElement = headsOffsetTops[index].id;
          break;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.download-qh {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);

  .white-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 700px;
    height: 480px;
    box-shadow: 0px 4px 24px rgba(85, 97, 117, 0.4);
    border-radius: 8px;
    text-align: left;
    background-image: url("../../assets/remote/download2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 30px;
      height: 30px;
      background-image: url("../../assets/remote/help8.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }

    .back {
      position: absolute;
      top: 16px;
      left: 16px;
      width: 30px;
      height: 30px;
      background-image: url("../../assets/remote/help9.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .title {
      font-weight: 500;
      font-size: 18px;
      line-height: 69px;
      text-align: center;
      color: #1f1f1f;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    .left-nav {
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 135px;
      height: 410px;
      box-sizing: border-box;
      border-right: 1px solid rgba(0, 0, 0, 0.05);
      .nav-item {
        padding-top: 21px;
        padding-bottom: 21px;
        line-height: 36px;
        text-align: center;
        color: #666666;
        font-size: 14px;
        cursor: pointer;
        .nav-icon {
          display: inline-block;
          margin-top: 2px;
          margin-right: 10px;
          vertical-align: top;
          width: 30px;
          height: 30px;
          line-height: 30px;
          background-image: url("../../assets/remote/download3.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .nav-item2 {
        .nav-icon {
          background-image: url("../../assets/remote/download4.svg");
        }
      }

      .active-item1 {
        font-weight: 600;
        color: #000000;
        .nav-icon {
          margin-top: -1px;
          margin-right: 7px;
          width: 36px;
          height: 36px;
          background-image: url("../../assets/remote/download16.svg");
        }
      }
      .active-item2 {
        font-weight: 600;
        color: #000000;
        .nav-icon {
          margin-top: -1px;
          margin-right: 7px;
          width: 36px;
          height: 36px;
          background-image: url("../../assets/remote/download17.svg");
        }
      }
      .contact {
        position: absolute;
        bottom: 12px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 105px;
        height: 36px;
        line-height: 36px;
        border: 1px solid rgba(20, 57, 119, 0.1);
        border-radius: 6px;
        text-align: center;
        font-size: 12px;
        color: #143977;
        z-index: 9;
        .contact-icon {
          display: inline-block;
          margin-top: 8px;
          margin-right: 11px;
          vertical-align: top;
          width: 20px;
          height: 20px;
          background-image: url("../../assets/remote/download6.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .contact-alert {
          position: absolute;
          bottom: 5px;
          left: -15px;
          width: 251px;
          height: 280px;
          background-image: url(../../assets/remote/contact-alert-bg.png);
          background-size: 251px 280px;
          background-repeat: no-repeat;
          font-size: 0;
          display: none;
          z-index: 9;
          img {
            margin: 0 auto;
            margin-top: 40px;
            width: 160px;
            height: 160px;
            padding-right: 16px;
            display: block;
            background-color: #ffffff;
          }
          .contact-alert-tips {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
            padding-right: 16px;
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }
      .contact:hover {
        cursor: pointer;
        .contact-alert {
          display: block;
        }
      }
    }
    .right {
      display: inline-block;
      padding-top: 20px;
      padding-bottom: 30px;
      vertical-align: top;
      width: 562px;
      height: 410px;
      box-sizing: border-box;
      overflow-y: scroll;
      .content-title {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #1f1f1f;
        .title-icon {
          display: inline-block;
          margin-right: 7px;
          margin-left: 21px;
          margin-top: 2px;
          vertical-align: top;
          width: 15px;
          height: 19px;
          background-image: url("../../assets/remote/download7.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .content-text {
        margin-left: 44px;
        margin-top: 10px;
        font-size: 14px;
        line-height: 19px;
        color: #666666;
        span {
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }
      }
      .content-text2 {
        display: inline-block;
        margin-left: 44px;
        margin-top: 30px;
        vertical-align: top;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #1f1f1f;
      }
      .content-title2 {
        margin-top: 20px;
        .title-icon {
          background-image: url("../../assets/remote/download8.svg");
        }
      }
      .content-title3 {
        margin-top: 20px;
        .title-icon {
          background-image: url("../../assets/remote/download9.svg");
        }
      }
      .content-text3 {
        position: relative;
        padding-left: 11px;
        padding-top: 13px;
        padding-right: 50px;
        margin-top: 10px;
        margin-left: 44px;
        width: 325px;
        height: 45px;
        line-height: 19px;
        background-color: #f3f5f7;
        border-radius: 4px;
        font-size: 14px;
        color: #143977;
        box-sizing: border-box;
        word-break: break-all;
      }
      .content-text3:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .content-text3:after {
        position: absolute;
        content: "";
        right: 16px;
        top: 10px;
        width: 24px;
        height: 24px;
        background-image: url("../../assets/remote/download10.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .content-title4 {
        margin-top: 20px;
        .title-icon {
          background-image: url("../../assets/remote/download11.svg");
        }
      }
      .content-title5 {
        margin-top: 20px;
        .title-icon {
          background-image: url("../../assets/remote/download13.svg");
        }
      }
      .content-title6 {
        margin-top: 20px;
        .title-icon {
          background-image: url("../../assets/remote/download14.svg");
        }
      }
    }
  }
}
</style>